// Copyright (c) 2016 Deere & Company

import ThemeSettings from '../../user/theme-settings/state-connector';

export default {
    component: ThemeSettings,
    name: 'THEME',
    path: 'theme'
};



// WEBPACK FOOTER //
// ./src/routes/settings/theme.js